import { useEffect, useState } from 'react'
import { storyCardsApi } from '../services/api'
import { resolveMediaUrl } from '../utils/media'

function normalizeStoryCard(item) {
  return {
    ...item,
    image: item?.image ? resolveMediaUrl(item.image) : item?.image,
  }
}

export function useStoryCards(type) {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!type) {
      setItems([])
      setLoading(false)
      return
    }

    setLoading(true)
    storyCardsApi
      .getAll({ type })
      .then(({ data }) => setItems((data.data || data || []).map(normalizeStoryCard)))
      .catch(() => setItems([]))
      .finally(() => setLoading(false))
  }, [type])

  return { items, loading }
}

export default useStoryCards
